export type ColumnTypeOption =
  | 'text'
  | 'image'
  | 'video'
  | 'link'
  | 'chart'
  | 'sparkline'
  | 'progressbar'
  | 'checkbox'
  | 'radio'
  | 'switch'
  | 'button';
export type HeaderTypeOption = 'text' | 'image' | 'video' | 'link' | 'checkbox';
